import styled from 'styled-components';
import { breakpoints } from '../../../../../styles/theme';
import { FaqItemStyled } from '../FaqItemStyled';
import { rem } from 'polished';

export const FaqItemStyledOV = styled(FaqItemStyled)`
    &.faqCategory {
        background-color: ${({ theme }) => theme.colors.pureWhite};

        > .Collapsible {
            max-width: ${rem(900)};
            margin: 0 auto;
            border: 1px solid;
            border-color: ${({ theme }) => theme.colors.grey21};
            margin-bottom: 10px;

            > .Collapsible__trigger {
                border-bottom: none;
                padding-left: ${rem(24)};

                > .faqHeader {
                    color: ${({ theme }) => theme.colors.accordionAnswer};
                    font-family: ${({ theme }) => theme.fonts.fontBase};
                    font-size: ${({ theme }) => theme.fontSizes.h4};
                    font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                    margin-left: ${rem(30)};
                    &:after {
                        margin-top: -17px;
                        width: 32px;
                        height: 32px;
                        background-position: center center;
                        background-size: 100%;
                        background-color: ${({ theme }) => theme.colors.pureWhite};
                        left: ${rem(12)};
                        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3E%3Cpath id='Tracé_192' d='M24.48 16.96h-7.52v7.52h-1.92v-7.52H7.52v-1.92h7.52V7.52h1.92v7.52h7.52z'/%3E%3C/svg%3E ");
                    }
                }
                &.is-open {
                    > .faqHeader {
                        &:after {
                            margin-top: -17px;
                            background-position: center center;
                            background-size: 50%;
                            background-color: ${({ theme }) => theme.colors.primary};
                            width: 32px;
                            height: 32px;
                            left: ${rem(12)};
                            background-image: url("data:image/svg+xml,%3Csvg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0' y='6' width='15' height='2' style='fill:%231A1B1B;'/%3E%3C/svg%3E%0A");
                        }
                    }
                }
            }
            .Collapsible__contentOuter {
            }
            .Collapsible__contentInner {
                .categoryContent {
                    padding: 0 ${rem(24)};
                    p strong,
                    p span strong,
                    p span {
                        font-family: ${({ theme }) => theme.fonts.fontBase}!important;
                        color: ${({ theme }) => theme.colors.black1}!important;
                    }
                    > p:nth-child(2n + 0) {
                        padding-bottom: 2rem;
                    }
                    a,
                    a span {
                        color: ${({ theme }) => theme.colors.black2}!important;
                        font-weight: ${({ theme }) => theme.fontWeights.textBold};
                        :hover {
                            color: ${({ theme }) => theme.colors.black2}!important;
                        }
                    }
                }
            }
        }
    }
    &.faqGroup {
        > .Collapsible {
            > .Collapsible__trigger {
                background-color: ${({ theme }) => theme.colors.pureWhite};
                padding: ${rem(11)} ${rem(30)} ${rem(11)} ${rem(24)};
                margin-left: 40px;
                margin-right: 40px;
                border: 1px solid ${({ theme }) => theme.colors.grey3};
                border-left: 0;
                border-right: 0;

                > .faqHeader {
                    font-weight: ${({ theme }) => theme.fontWeights.textBold};
                    color: ${({ theme }) => theme.colors.black1};
                    padding-right: ${rem(32)};
                    margin-left: ${rem(20)};

                    &:after {
                        left: ${rem(16)};
                        height: ${rem(15)};
                        width: ${rem(15)};
                        margin-top: ${rem(-8)};
                        background-image: url("data:image/svg+xml,%3Csvg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6 5.99999V0.827608V0H9V0.827608V5.99999H14.1725H15.0001V8.99999H14.1725H9V14.1724V15H6V14.1724V8.99999H0.827615H0V5.99999H0.827615H6Z' fill='%23000'/%3E%3C/svg%3E");
                    }
                }

                &.is-open {
                    > .faqHeader {
                        &:after {
                            left: ${rem(16)};
                            background-image: url("data:image/svg+xml,%3Csvg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0' y='6' width='15' height='3' style='fill:%23000'/%3E%3C/svg%3E%0A");
                        }
                    }
                }
            }

            > .Collapsible__contentOuter {
                background-color: ${({ theme }) => theme.colors.pureWhite};

                > .Collapsible__contentInner {
                    margin-left: 40px;
                    margin-right: 40px;
                    padding: 0 ${rem(24)};

                    a,
                    a span {
                        color: ${({ theme }) => theme.colors.black2}!important;
                        font-weight: ${({ theme }) => theme.fontWeights.textBold};
                        :hover {
                            color: ${({ theme }) => theme.colors.black2}!important;
                        }
                    }
                    strong {
                        font-family: ${({ theme }) => theme.fonts.fontBase};
                    }
                    span {
                        color: ${({ theme }) => theme.colors.black1}!important;
                    }
                }
            }
        }
    }

    &.secondary {
        .Collapsible__trigger {
            border: none;
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
        .Collapsible__trigger:after {
            background-image: url("data:image/svg+xml,%3Csvg width='19' height='11' viewBox='0 0 26 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 13L13 1L25 13' stroke='%23AD9D91' stroke-width='1' stroke-linejoin='bevel'/%3E%3C/svg%3E ");
        }

        .question {
            font-family: ${({ theme }) => theme.fonts.fontEmphasized};
        }
        .answer {
            color: ${({ theme }) => theme.colors.accordionAnswer};
        }
    }
    &.primary {
        .Collapsible__trigger {
            border: 1px solid ${({ theme }) => theme.colors.secondary};
            color: ${({ theme }) => theme.colors.secondary};
            font-family: ${({ theme }) => theme.fonts.fontEmphasized};
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }

        .Collapsible__trigger:after {
            margin-top: ${rem(-3)};
            height: ${rem(8)};
            width: ${rem(14)};

            background-image: url("data:image/svg+xml,%3Csvg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.25 8L0 6.7392L7 0L14 6.7392L12.75 8L7 2.4L1.25 8Z' fill='%23AD9D91'/%3E%3C/svg%3E ");
        }
        .Collapsible__trigger.is-open:after {
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.25 8L0 6.7392L7 0L14 6.7392L12.75 8L7 2.4L1.25 8Z' fill='%23AD9D91'/%3E%3C/svg%3E ");
            height: ${rem(8)};
            width: ${rem(14)};
            transform: rotate(0);
        }
    }
`;
